import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaidFeatureUpgradeStep} from "../../paid-feature-upgrade.component";
import {GoogleAnalyticsService} from "../../../../../services/google-analytics/google-analytics.service";
import {ChosenPlan} from "../../../../payment-info/models/plan.model";
import {UserSubscription} from "../../../../../../user/user-subscription";

export type PaidFeatureUpgradeMode = 'ssh' | 'cloudflare' | 'regenerate' | 'pro-level' | 'passwordProtect' | 'professional';

@Component({
    selector: 'db-paid-feature-upgrade-plans',
    templateUrl: './paid-feature-upgrade-plans.component.html',
    styleUrls: ['./paid-feature-upgrade-plans.component.scss'],
    standalone: false
})
export class PaidFeatureUpgradePlansComponent implements OnInit {

  @Input() isAgency = false;
  @Input() mode: PaidFeatureUpgradeMode;
  @Input() chosenPlan: ChosenPlan;
  @Input() expirationDate: string;
  @Input() currentSubscription: UserSubscription;
  @Output() onStepChange = new EventEmitter<PaidFeatureUpgradeStep>();
  @Output() onPlanChange = new EventEmitter<ChosenPlan>();

  constructor(
    private readonly _googleAnalyticsService: GoogleAnalyticsService,

  ) { }

  ngOnInit() {
  }

  public proceedToCheckout(): void {
    let analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: 'Checkout Page visit (purchase pop-up)',
      eventLabel: this.currentSubscription.title + (this.currentSubscription.plan.periodNumber === 12 ? ' Yearly' : ' Monthly')
    };
    if (this.mode === 'pro-level') {
       analyticsData = {
        eventCategory: 'Dashboard Action',
        eventAction: 'Checkout Page visit (Pro level pop-up)',
        eventLabel: this.chosenPlan.title
      };
    }

    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this.onStepChange.emit('checkout');
  }

}
